import React from 'react';
import TradeNowButton from './tradeNowButton';
import CountDown from '../../components/countDown';
import { getPeriodForPresentation } from '../../services/utils';

class ProductItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isExpired: false,
            isGlowing: false
        };
        
        this.hasExpired = this.hasExpired.bind(this);
    }

    componentDidMount() {
        this.setIsExpired(this.props);
        this.setIsGlowing(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.row != this.props.row) {
            this.setIsExpired(nextProps);
            this.setIsGlowing(nextProps);
        }
    }

    setIsExpired(props) {
        let isExpired = false;
        const { status, expiry_time } = props.row;

        if (status == 'EXPIRED') {
            isExpired = true;
        } else if (expiry_time == null || new Date(expiry_time) >= new Date()) {
            isExpired = false;
        }
        this.setState({ isExpired })
    }

    hasExpired() {
        this.setState({ isExpired: true });
        this.props.orderHasExpired();
    }

    setIsGlowing(props) {
        const { created_seconds_ago, updated_seconds_ago } = props.row;
        const glowTime = typeof updated_seconds_ago === 'number' 
                ? (300 - updated_seconds_ago) 
                : (300 - created_seconds_ago);
        this.setState({ isGlowing: glowTime > 0 });

        if (glowTime > 0) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.setState({ isGlowing: false });
            }, 1000 * glowTime)
        }
    }

    render() {
        let { 
            row, rowIndex, user, showExpandButton, isExpanded, isVisible, onExpand, 
            collapsedClass, glowExpandButton 
        } = this.props;
                
        return (
            <tr name='order_line'
                style={{display: isVisible ? 'table-row' : 'none'}}
                onMouseOver={this.props.onMouseOver}
                onMouseOut={this.props.onMouseOut}
                
                orderid_sell={row.intent === 'SELL' ? row.id : null}
                creator_company_id_sell={row.intent === 'SELL' ? row.creator_company_id : null}
                price_sell={row.intent === 'SELL' ? row.price : null}
                quantity_sell={row.intent === 'SELL' ? row.quantity : null}
                status_sell={row.intent === 'SELL' ? row.status : null}
                isexpired_sell={+this.state.isExpired}
                orderid_buy={row.intent === 'BUY' ? row.id : null}
                creator_company_id_buy={row.intent === 'BUY' ? row.creator_company_id : null}
                price_buy={row.intent === 'BUY' ? row.price : null}
                quantity_buy={row.intent === 'BUY' ? row.quantity : null}
                status_buy={row.intent === 'BUY' ? row.status : null}
                isexpired_buy={+this.state.isExpired}

                productid={row.product_id}
                contract_type={row.contract_type}
                trading_period={row.trading_period}
                currency={row.currency_id}
                className={'worklog-row ' + (row.status == 'OPEN' && 'open ') + collapsedClass}>
                <td className='worklog-row-item worklog-row-intent'>
                    <TradeNowButton
                        placeOrder={this.props.placeOrder}
                        row={row}
                        status={row.status}
                        intent={row.intent}
                        type={row.type}
                        id={row.id}
                        user={this.props.user}
                        isExpired={this.state.isExpired}
                        showTraded={row.show_traded}
                        contractType={row.contract_type}
                        showOrderPopup={this.props.showOrderPopup}
                        getOrder={this.props.getOrder}
                        callDH={this.props.callDH}
                        isOwner={row.creator_company_id === this.props.user.userInfo.company_id} 
                        glow={this.state.isGlowing} />
                </td>
                <td className='worklog-row-item worklog-row-productname'>
                    <div className='productname-holder'>
                        {row.product_short_name}
                    </div>
                    {showExpandButton ?
                        <span 
                            className={`expand-button ${glowExpandButton ? 'glowing' : ''}`} 
                            onClick={onExpand}
                        >
                            {isExpanded ? '-' : '+'}
                        </span>
                    : ''}
                </td>
                <td className='worklog-row-item worklog-row-price flex-small'>{row.price + ' ' + row.currency_id}</td>
                <td className='worklog-row-item worklog-row-tradingperiod flex-small'>{getPeriodForPresentation(row.trading_period_prefix, row.trading_period)}</td>
                <td className='worklog-row-item worklog-row-quantity'>{row.quantity + ' ' + row.unit_abbreviation}</td>                
                <td className='worklog-row-item worklog-row-otccme flex-small'>{row.contract_type}</td>                                                
                {user.isAdmin || user.isSuperUser ?
                    <td className='worklog-row-item worklog-row-counterpart'><div className='counterpart-holder'>
                        {row.intent === 'SELL' && row.accepted_by_company_name ? row.accepted_by_company_name : row.creator_company_name}
                    </div></td>
                : null}                
                <td className='worklog-row-item worklog-row-expires flex-small'>
                    { !(this.state.isExpired || row.show_traded) ?
                        row.expiry_time == null ? 'GTC' :
                            <CountDown
                                expiryTime={row.expiry_time}
                                hasExpired={this.hasExpired} />
                    : <div className='expired'>{ this.state.isExpired ? 'EXPIRED' : 'TRADED'}</div> }

                </td>
            </tr>
        )
    }

}


export default ProductItem;



// WEBPACK FOOTER //
// ./source/screens/markets/productItem.js